import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'What We Do',
    path: '/what-we-do'
  }, {
    name: 'Platform',
    path: '/platform'
  }, {
    name: 'Use Cases',
    path: '/use-cases'
  }, {
    name: 'Why SURE AI',
    path: '/why-sure-ai'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  const isActive = (path: string) => {
    if (path === '/' && location.pathname !== '/') return false;
    return location.pathname.startsWith(path);
  };
  return <>
      <nav className="fixed top-0 left-0 right-0 z-50 bg-sure-black/80 backdrop-blur-md border-b border-white/5" data-id="element-114">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 h-20 flex items-center justify-between" data-id="element-115">
          {/* Left: Wordmark */}
          <div className="flex-shrink-0 z-50" data-id="element-116">
            <Link to="/" className="text-sure-white text-xl font-bold tracking-wider" onClick={() => setIsOpen(false)} data-id="element-117">
              SURE AI
            </Link>
          </div>

          {/* Center: Nav Links (Desktop) */}
          <div className="hidden lg:flex items-center space-x-8" data-id="element-118">
            {navLinks.map(item => <Link key={item.name} to={item.path} className={`text-xs uppercase tracking-widest transition-colors duration-300 ${isActive(item.path) ? 'text-sure-accent' : 'text-sure-white hover:text-sure-accent'}`} data-id="element-119">
                {item.name}
              </Link>)}
          </div>

          {/* Right: CTA & Mobile Toggle */}
          <div className="flex items-center space-x-4 z-50" data-id="element-120">
            <div className="hidden sm:block" data-id="element-121">
              <Link to="/contact" className="px-6 py-2.5 border border-sure-white text-sure-white text-xs uppercase tracking-widest hover:bg-sure-white hover:text-sure-black transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-sure-accent focus:ring-offset-2 focus:ring-offset-sure-black inline-block" data-id="element-122">
                Request a Briefing
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button className="lg:hidden text-sure-white p-2 focus:outline-none" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu" data-id="element-123">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-124">
                {isOpen ? <>
                    <line x1="18" y1="6" x2="6" y2="18" data-id="element-125"></line>
                    <line x1="6" y1="6" x2="18" y2="18" data-id="element-126"></line>
                  </> : <>
                    <line x1="3" y1="12" x2="21" y2="12" data-id="element-127"></line>
                    <line x1="3" y1="6" x2="21" y2="6" data-id="element-128"></line>
                    <line x1="3" y1="18" x2="21" y2="18" data-id="element-129"></line>
                  </>}
              </svg>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-130">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        duration: 0.3
      }} className="fixed inset-0 z-40 bg-sure-black pt-24 px-6 pb-6 lg:hidden overflow-y-auto" data-id="element-131">
            <div className="flex flex-col space-y-6 mt-8" data-id="element-132">
              {navLinks.map(item => <Link key={item.name} to={item.path} onClick={() => setIsOpen(false)} className={`text-lg uppercase tracking-widest ${isActive(item.path) ? 'text-sure-accent' : 'text-sure-white'}`} data-id="element-133">
                  {item.name}
                </Link>)}
              <div className="pt-8 border-t border-white/10 mt-8" data-id="element-134">
                <Link to="/contact" onClick={() => setIsOpen(false)} className="w-full text-center px-6 py-4 border border-sure-white text-sure-white text-sm uppercase tracking-widest hover:bg-sure-white hover:text-sure-black transition-all duration-300 block" data-id="element-135">
                  Request a Briefing
                </Link>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}